<template>
  <div>
    <div class="results_container">
      <div class="block">
        <div class="block-header">
          <div class="input-group input-group-sm">
            <input
              v-model="searchStr"
              type="text"
              class="form-control form-control-alt search-project"
              placeholder="Expert Search..."
            >
            <div class="input-group-append">
              <span class="input-group-text bg-body border-0">
                <i class="si si-magnifier" />
              </span>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="loading"
        class="d-flex justify-content-center mb-3"
      >
        <b-spinner
          style="width: 3rem; height: 3rem;"
          type="grow"
          label="Fetching Experts"
          variant="primary"
        />
      </div>
      <div v-else>
        <expert-result-block
          v-for="(user) in usersComputed"
          :key="user.id"
          :user="user"
          :current-route-name="currentRouteName"
          :routes="routesComputed"
          :wpmessage="wpmessageComputed"
          :hide-job-experiences="hideJobExperiencesComputed"
          :me="meComputed"
          :all-assignment-statuses="allAssignmentStatusesComputed"
          :project="project"
          :questions="questions"
          :project-staffs="projectStaffs"
          :user-logged-id="userLoggedId"
          @updated="getUsers"
        />

        <vue-pagination
          :data="$store.state.expert.usersExpertsObj"
          @pagination-change-page="getUsers"
        />
      </div>
    </div>
  </div>
</template>
<script>
import mixin from '../../../mixins/mixin'

export default {
    name: 'ExpertSimpleList',
    mixins: [mixin],
    props: {
        usersInit: {
            type: String,
            required: true,
        },
        currentRouteName: {
            type: String,
            required: false,
            default () {
                return ''
            },
        },
        allAssignmentStatusesInit: {
            type: String,
            required: false,
            default () {
                return ''
            },
        },
        attachedJobExperienceIdsInit: {
            type: String,
            required: false,
            default () {
                return ''
            },
        },
        projectInit: {
            type: String,
            required: false,
            default () {
                return null
            },
        },
        questionsInit: {
            type: String,
            required: false,
            default () {
                return ''
            },
        },
        projectStaffs: {
            type: Array,
            required: false,
            default () {
                return []
            },
        },
        userLoggedId: {
            type: Number,
            required: false,
            default () {
                return null
            },
        },
    },
    data () {
        return {
            url: '/admin/experts/api/index',
            users: {},
            wpmessage: '',
            extraStringRaw: '',
            hideJobExperiences: false,
            searchStr: '',
            myUser: {},
            routes: [],
            allAssignmentStatuses: [],
            attachedJobExperienceIds: [],
            project: {},
            questions: [],
            loading: false,
        }
    },
    computed: {
        usersComputed () {
            return this.$store.state.expert.usersExpertsObj.data
        },
        routesComputed () {
            return this.routes || []
        },
        wpmessageComputed () {
            return this.wpmessage || ''
        },
        extraString () {
            return this.extraStringRaw
        },
        total () {
            return this.users.total || 0
        },
        hideJobExperiencesComputed () {
            return this.$store.state.expert.hideJobExperiencesComputed
        },
        meComputed () {
            return this.myUser
        },
        allAssignmentStatusesComputed () {
            return this.allAssignmentStatuses || []
        },
    },
    watch: {
        searchStr: async function (value, oldVal) {
            if (value.length >= 2 || (oldVal.length > value.length && value.length === 0)) {
                await this.$store.commit('expert/setExpertKeyword', value)
                await this.searchString()
            }
        },
    },
    mounted () {
        const users = JSON.parse(this.usersInit)
        this.$store.commit('expert/setUsersExpertsObj', users)
        this.project = JSON.parse(this.projectInit)
        this.questions = JSON.parse(this.questionsInit)
        this.allAssignmentStatuses = this.allAssignmentStatusesInit.length > 0 ? JSON.parse(
            this.allAssignmentStatusesInit) : []
        this.attachedJobExperienceIds = this.attachedJobExperienceIdsInit.length > 0 ? JSON.parse(
            this.attachedJobExperienceIdsInit) : []
        this.getMyUser().then(u => (this.myUser = u))

        if(window.NodesPermissions.length === 0) {
            this.getPermittedRoutes().then(res => {
                this.routes = res
                this.$store.commit('routes/setRoutePermissions', res)
            })
        } else {
            this.routes = window.NodesPermissions
            this.$store.commit('routes/setRoutePermissions', window.NodesPermissions)
        }
        this.getSingleWpMessage('expert.whatsapp_preset_message1').then(res => (this.wpmessage = res))

        //get payment request of this project
        this.$store.dispatch('project/payment/getRequestSentList', { projectId: this.project.id, staffId: this.userLoggedId })
    },
    methods: {
        searchString: _.debounce(function () {
            console.log('get user')
            this.getUsers()
        }, 300),
        markString (str) {
            this.searchStr = str
        },
        async getUsers (page = 1) {
            this.loading = true
            await this.$store.dispatch('expert/getProjectExperts', { projectId: this.project.id, page: page })
            this.loading = false
        },
        setDisplayOptions (payload) {
            if (payload && payload.id === 'hideJobExperiences') {
                this.hideJobExperiences = payload.status
            }
        },
    }
}
</script>
